<div class="data-load-error" [ngClass]="[type]">
  <svg-icon src="assets/icons/warning.svg"></svg-icon>
  <div class="data-load-error--text">
    {{ 'global.dataLoadErrorReload' | translate }}
  </div>
</div>

